import { Alert } from "@mui/material";
import * as React from "react";
import { Navigate, useRouteError } from "react-router";

import { PageLayout } from "@/shared/components/PageLayout";
import { RobotoUnauthorizedException } from "@/shared/http";
import { Goto } from "@/shared/navigation";
import { ErrorMonitoringService } from "@/shared/services/ErrorMonitoringService";

import {
  InvalidWorkspaceConfigError,
  WorkspaceNotFoundError,
} from "../loader/exceptions";

/**
 * Top-most error boundary for the visualization workspace.
 *
 * Reference: https://reactrouter.com/en/main/route/error-element
 */
export function ErrorBoundary() {
  const error = useRouteError();

  React.useEffect(() => {
    ErrorMonitoringService.captureError(error);
  }, [error]);

  if (error instanceof RobotoUnauthorizedException) {
    return <Navigate to={Goto.route.Unauthorized} replace />;
  }

  const errorMessage = toErrorMessage(error);

  return (
    <PageLayout title={"Roboto - Visualization"}>
      <div>
        <Alert severity="error">{errorMessage}</Alert>
      </div>
    </PageLayout>
  );
}

function toErrorMessage(error: unknown): string {
  if (
    error instanceof InvalidWorkspaceConfigError ||
    error instanceof WorkspaceNotFoundError
  ) {
    return error.message;
  }

  return "Something went wrong loading the visualization workspace. Please try reloading the page.";
}
